<template>
  <div class="upload-file">
    <label
      @click="handleFileSelect"
      v-loading="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <i class="el-icon-plus"></i>
    </label>
    <input ref="fileInput" :accept="accept" @change="change" type="file" />
  </div>
</template>

<script>
import CommonFile from '@/api/common';
export default {
  name: 'UploadFile',
  data() {
    return {
      loading: false,
    };
  },
  props: {
    accept: {
      type: String,
      default: 'image/*',
    },
  },
  methods: {
    handleFileSelect() {
      const { validity } = this.$listeners;
      if (validity) {
        const result = validity();
        // 进行前置校验
        if (result) {
          this.$refs['fileInput'].click();
        } else {
          this.$message({
            message: '请先签到',
            type: 'warning',
          });
        }
      } else {
        this.$refs['fileInput'].click();
      }
    },
    async change(e) {
      this.loading = true;
      const target = e.target;
      const selectedFiles = Array.from(target.files);
      for (const file of selectedFiles) {
        if ((file.size / (1024 * 1024)).toFixed(2) > 100) {
          this.$message.error('文件过大！');
          return;
        }
        try {
          const res = await CommonFile.commonUploadFile('zngy', file);
          if (res.data.code == 200) {
            this.$emit('imageDataHandle', res.data.data);
          } else {
            this.$message.error(res.data.message);
          }
        } catch (error) {
          // console.log(error)
        } finally {
          target.value = '';
        }
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-file {
  label {
    border: 1px solid #ccc;
    cursor: pointer;
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  input {
    display: none;
  }
}
</style>
